import { createApi } from "@reduxjs/toolkit/query/react";
import { AUTH } from "../../configs";
import { HttpMethod, LoginData, LoginResponse } from "../../types";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const authApi = createApi({
  reducerPath: AUTH.reducerPath,
  baseQuery: createBaseQuery(AUTH.baseUrl),
  tagTypes: AUTH.tagTypes,
  endpoints(builder) {
    return {
      login: builder.mutation<LoginResponse, LoginData>({
        query: (body) => ({
          url: "/admin/login",
          method: HttpMethod.POST,
          body,
        }),
      }),
    };
  },
});

export const { useLoginMutation } = authApi;

export { authApi };
